<style lang="less" scoped>
@import '../../../style/common/variable';
.tradingFloor{position: relative;display: flex;flex-direction: column;justify-content:center;align-items:center;margin: 0;padding: 0;background: #fff;}
p{width: 1200px;height: 300px;margin: 20px auto;}
/* 移动端适配 */
@media screen and (max-width: @max-screen) {
  .tradingFloor{width: 100%;
    p{width:100%;}
  }
}
</style>

<template>
  <div class="tradingFloor">
    <p>该页面正在建设当中···</p>
  </div>
</template>

<script>
export default {
    
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/TradingFloor.vue